module.exports = __webpack_public_path__ + "static/media/spinner.320b5248.svg";